var _defs, _path, _path2, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogologin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 377,
    zoomAndPan: "magnify",
    viewBox: "0 0 283.5 283.500005",
    height: 377,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "f944e868c2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 139.90625 L 17.679688 139.90625 L 17.679688 143.03125 L 0 143.03125 Z M 0 139.90625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3086f127f2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 17.671875 141.484375 L 17.675781 141.203125 C 17.691406 140.792969 17.472656 140.566406 17.203125 140.554688 L 0.515625 139.917969 C 0.234375 139.910156 0 140.136719 0 140.417969 L 0 142.53125 C 0 142.820312 0.242188 143.046875 0.53125 143.03125 L 17.203125 141.984375 C 17.464844 141.96875 17.671875 141.753906 17.671875 141.492188 Z M 17.671875 141.484375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c74243609b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.949219 119.089844 L 21.933594 119.089844 L 21.933594 133.160156 L 7.949219 133.160156 Z M 7.949219 119.089844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7b9ae96faa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 21.730469 131.523438 L 10.351562 119.304688 C 10.15625 119.097656 9.832031 119.089844 9.632812 119.289062 L 8.121094 120.800781 C 7.921875 121 7.925781 121.324219 8.128906 121.515625 L 20.253906 133.007812 C 20.457031 133.203125 20.777344 133.183594 20.964844 132.972656 L 21.699219 132.234375 C 21.902344 132.042969 21.921875 131.726562 21.730469 131.523438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5358a2b920"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.589844 130.957031 L 18.796875 130.957031 L 18.796875 137.570312 L 6.589844 137.570312 Z M 6.589844 130.957031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8bbcba3d96"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 18.484375 135.742188 L 7.9375 131.03125 C 7.675781 130.917969 7.375 131.039062 7.269531 131.300781 L 6.671875 132.78125 C 6.566406 133.042969 6.695312 133.339844 6.957031 133.4375 L 17.78125 137.484375 C 18.035156 137.578125 18.328125 137.453125 18.421875 137.191406 L 18.742188 136.390625 C 18.851562 136.140625 18.734375 135.851562 18.484375 135.738281 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "79fe00947f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 19.390625 117.90625 L 26.085938 117.90625 L 26.085938 130.109375 L 19.390625 130.109375 Z M 19.390625 117.90625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eb89b036df"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26.007812 129.058594 L 21.878906 118.269531 C 21.777344 118.003906 21.480469 117.875 21.21875 117.984375 L 19.746094 118.609375 C 19.488281 118.722656 19.371094 119.019531 19.488281 119.277344 L 24.28125 129.792969 C 24.394531 130.042969 24.6875 130.15625 24.9375 130.039062 L 25.734375 129.699219 C 25.984375 129.601562 26.109375 129.3125 26.007812 129.058594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5a81e57fef"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.738281 145.710938 L 18.945312 145.710938 L 18.945312 152.410156 L 6.738281 152.410156 Z M 6.738281 145.710938 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f7a13e3cca"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 17.894531 145.789062 L 7.101562 149.917969 C 6.839844 150.019531 6.710938 150.320312 6.820312 150.582031 L 7.445312 152.050781 C 7.554688 152.3125 7.855469 152.429688 8.109375 152.3125 L 18.625 147.519531 C 18.875 147.40625 18.988281 147.109375 18.871094 146.859375 L 18.53125 146.066406 C 18.433594 145.8125 18.144531 145.691406 17.890625 145.789062 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9a9cc2447e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.925781 149.867188 L 21.996094 149.867188 L 21.996094 163.851562 L 7.925781 163.851562 Z M 7.925781 149.867188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3bfc993b0c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 20.355469 150.070312 L 8.136719 161.449219 C 7.933594 161.640625 7.925781 161.964844 8.125 162.167969 L 9.632812 163.675781 C 9.832031 163.875 10.15625 163.871094 10.347656 163.667969 L 21.839844 151.546875 C 22.035156 151.34375 22.015625 151.019531 21.808594 150.832031 L 21.066406 150.101562 C 20.878906 149.898438 20.5625 149.878906 20.355469 150.070312 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7e7e7d2554"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 19.792969 153.003906 L 26.402344 153.003906 L 26.402344 165.207031 L 19.792969 165.207031 Z M 19.792969 153.003906 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: 3.84709e+168
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 24.574219 153.3125 L 19.867188 163.863281 C 19.75 164.121094 19.875 164.421875 20.132812 164.527344 L 21.617188 165.128906 C 21.878906 165.234375 22.171875 165.101562 22.269531 164.839844 L 26.316406 154.019531 C 26.414062 153.765625 26.285156 153.472656 26.027344 153.378906 L 25.222656 153.058594 C 24.976562 152.949219 24.6875 153.070312 24.574219 153.316406 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a9c7b679c6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 28.734375 111.167969 L 31.894531 111.167969 L 31.894531 128.863281 L 28.734375 128.863281 Z M 28.734375 111.167969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1d7f968cda"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 30.316406 128.835938 L 30.617188 128.84375 C 31.042969 128.859375 31.277344 128.644531 31.289062 128.367188 L 31.878906 111.683594 C 31.890625 111.398438 31.664062 111.167969 31.382812 111.167969 L 29.246094 111.167969 C 28.964844 111.167969 28.742188 111.398438 28.746094 111.679688 L 29.191406 128.371094 C 29.199219 128.648438 29.433594 128.871094 29.714844 128.855469 L 30.316406 128.835938 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6cb9ff17bd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 28.738281 154.097656 L 31.886719 154.097656 L 31.886719 171.808594 L 28.738281 171.808594 Z M 28.738281 154.097656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "22b115e212"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 30.316406 154.125 L 30.015625 154.125 C 29.585938 154.105469 29.355469 154.320312 29.34375 154.59375 L 28.75 171.28125 C 28.742188 171.5625 28.96875 171.800781 29.25 171.800781 L 31.386719 171.800781 C 31.667969 171.800781 31.890625 171.570312 31.886719 171.285156 L 31.441406 154.59375 C 31.433594 154.3125 31.199219 154.097656 30.917969 154.109375 L 30.316406 154.125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2f2fd899f3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 20.398438 139.898438 L 60.636719 139.898438 L 60.636719 143.0625 L 20.398438 143.0625 Z M 20.398438 139.898438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "da6fb42bf9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 20.398438 141.53125 L 20.398438 141.175781 C 20.398438 140.902344 20.617188 140.683594 20.890625 140.675781 L 60.125 139.910156 C 60.402344 139.90625 60.632812 140.128906 60.632812 140.410156 L 60.632812 142.554688 C 60.632812 142.835938 60.402344 143.058594 60.121094 143.050781 L 20.886719 142.03125 C 20.617188 142.023438 20.398438 141.800781 20.398438 141.53125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "676d3d5d58"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 41.699219 130.554688 L 53.90625 130.554688 L 53.90625 137.253906 L 41.699219 137.253906 Z M 41.699219 130.554688 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b052e07759"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 42.738281 137.175781 L 53.53125 133.046875 C 53.792969 132.945312 53.921875 132.644531 53.8125 132.382812 L 53.1875 130.914062 C 53.078125 130.652344 52.777344 130.539062 52.523438 130.652344 L 42.007812 135.445312 C 41.757812 135.558594 41.644531 135.855469 41.761719 136.105469 L 42.101562 136.898438 C 42.199219 137.152344 42.488281 137.273438 42.738281 137.175781 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "320047b467"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 38.648438 119.113281 L 52.71875 119.113281 L 52.71875 133.097656 L 38.648438 133.097656 Z M 38.648438 119.113281 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "af24011a15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 40.273438 132.898438 L 52.492188 121.515625 C 52.699219 121.324219 52.707031 121 52.507812 120.796875 L 50.996094 119.289062 C 50.796875 119.089844 50.472656 119.09375 50.28125 119.296875 L 38.792969 131.417969 C 38.597656 131.621094 38.617188 131.941406 38.828125 132.132812 L 39.566406 132.863281 C 39.753906 133.066406 40.070312 133.085938 40.277344 132.898438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "81adba565b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 34.242188 117.757812 L 40.851562 117.757812 L 40.851562 129.964844 L 34.242188 129.964844 Z M 34.242188 117.757812 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e17ec89c99"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 36.058594 129.652344 L 40.765625 119.101562 C 40.882812 118.84375 40.761719 118.542969 40.5 118.4375 L 39.015625 117.835938 C 38.753906 117.730469 38.460938 117.863281 38.363281 118.125 L 34.316406 128.945312 C 34.21875 129.203125 34.347656 129.492188 34.605469 129.585938 L 35.410156 129.90625 C 35.65625 130.019531 35.949219 129.902344 36.058594 129.652344 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fc78b2c753"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 34.546875 152.867188 L 41.242188 152.867188 L 41.242188 165.070312 L 34.546875 165.070312 Z M 34.546875 152.867188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b5e0733525"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 34.621094 153.90625 L 38.753906 164.699219 C 38.855469 164.960938 39.152344 165.089844 39.414062 164.980469 L 40.886719 164.355469 C 41.148438 164.246094 41.265625 163.945312 41.148438 163.6875 L 36.351562 153.171875 C 36.238281 152.925781 35.941406 152.808594 35.695312 152.925781 L 34.898438 153.265625 C 34.648438 153.367188 34.523438 153.652344 34.621094 153.90625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2b548f57ae"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 38.699219 149.816406 L 52.683594 149.816406 L 52.683594 163.886719 L 38.699219 163.886719 Z M 38.699219 149.816406 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f3d71d8591"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 38.902344 151.441406 L 50.28125 163.660156 C 50.476562 163.863281 50.800781 163.871094 51 163.671875 L 52.511719 162.164062 C 52.710938 161.964844 52.707031 161.640625 52.503906 161.449219 L 40.378906 149.957031 C 40.175781 149.761719 39.855469 149.78125 39.667969 149.992188 L 38.933594 150.730469 C 38.730469 150.921875 38.710938 151.238281 38.902344 151.441406 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5f7a565cc5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 41.835938 145.40625 L 54 145.40625 L 54 152 L 41.835938 152 Z M 41.835938 145.40625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c137bb5eca"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 42.148438 147.222656 L 52.695312 151.933594 C 52.957031 152.046875 53.257812 151.925781 53.363281 151.664062 L 53.960938 150.183594 C 54.066406 149.921875 53.9375 149.625 53.675781 149.527344 L 42.851562 145.480469 C 42.597656 145.386719 42.304688 145.515625 42.210938 145.773438 L 41.890625 146.574219 C 41.78125 146.824219 41.898438 147.113281 42.148438 147.226562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "35feffa42d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 66.253906 131.425781 L 87.867188 131.425781 L 87.867188 154.519531 L 66.253906 154.519531 Z M 66.253906 131.425781 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "686313efae"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 66.3125 142.972656 C 66.3125 136.441406 71.355469 131.484375 78.042969 131.484375 C 82.183594 131.484375 85.695312 133.378906 87.789062 136.386719 L 87.808594 136.496094 L 83.617188 139.09375 C 83.574219 139.121094 83.515625 139.109375 83.488281 139.066406 C 82.292969 137.371094 80.324219 136.277344 78.042969 136.277344 C 74.285156 136.277344 71.421875 139.144531 71.421875 142.972656 C 71.421875 146.800781 74.28125 149.664062 78.042969 149.664062 C 80.324219 149.664062 82.292969 148.570312 83.488281 146.875 L 83.574219 146.820312 L 87.761719 149.417969 C 87.808594 149.449219 87.820312 149.511719 87.789062 149.558594 C 85.695312 152.566406 82.183594 154.460938 78.046875 154.460938 C 71.355469 154.460938 66.3125 149.503906 66.3125 142.972656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ca21ba3664"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 89.9375 131.820312 L 107.902344 131.820312 L 107.902344 154.125 L 89.9375 154.125 Z M 89.9375 131.820312 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6647ba72d7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 94.953125 142.039062 L 94.996094 142.136719 L 99.484375 142.136719 C 101.027344 142.136719 102.183594 140.945312 102.183594 139.371094 C 102.183594 137.761719 101.027344 136.570312 99.484375 136.570312 L 95.050781 136.570312 C 94.996094 136.570312 94.953125 136.613281 94.953125 136.667969 Z M 97.308594 146.480469 L 95.046875 146.480469 C 94.992188 146.480469 94.949219 146.523438 94.949219 146.578125 L 94.949219 153.976562 C 94.949219 154.03125 94.90625 154.074219 94.851562 154.074219 L 90.070312 154.074219 C 90.015625 154.074219 89.96875 154.03125 89.96875 153.976562 L 89.96875 131.964844 C 89.96875 131.910156 90.015625 131.867188 90.070312 131.867188 L 99.582031 131.867188 C 103.984375 131.867188 107.296875 135.054688 107.296875 139.304688 C 107.296875 142.382812 105.511719 144.804688 102.839844 145.890625 L 102.761719 145.976562 L 107.8125 153.921875 C 107.855469 153.988281 107.808594 154.074219 107.730469 154.074219 L 101.984375 154.074219 C 101.949219 154.074219 101.917969 154.054688 101.898438 154.027344 L 97.390625 146.527344 C 97.375 146.496094 97.339844 146.480469 97.308594 146.480469 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e9fd1788de"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 108.492188 131.425781 L 131.984375 131.425781 L 131.984375 154.519531 L 108.492188 154.519531 Z M 108.492188 131.425781 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "124538a016"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 126.875 142.972656 C 126.875 139.144531 124.011719 136.277344 120.25 136.277344 C 116.488281 136.277344 113.628906 139.144531 113.628906 142.972656 C 113.628906 146.800781 116.492188 149.664062 120.253906 149.664062 C 124.015625 149.664062 126.875 146.800781 126.875 142.972656 M 108.519531 142.972656 C 108.519531 136.441406 113.566406 131.484375 120.25 131.484375 C 126.90625 131.484375 131.984375 136.441406 131.984375 142.972656 C 131.984375 149.503906 126.902344 154.460938 120.25 154.460938 C 113.5625 154.460938 108.519531 149.503906 108.519531 142.972656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c6f2dc0695"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 134.460938 131.871094 L 153.761719 131.871094 L 153.761719 154.097656 L 134.460938 154.097656 Z M 134.460938 131.871094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e0db156d11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 153.683594 131.96875 L 153.683594 153.976562 C 153.683594 154.03125 153.640625 154.078125 153.585938 154.078125 L 148.691406 154.078125 C 148.660156 154.078125 148.628906 154.058594 148.609375 154.03125 L 139.625 140.761719 C 139.570312 140.679688 139.445312 140.71875 139.445312 140.816406 L 139.445312 153.976562 C 139.445312 154.03125 139.402344 154.078125 139.347656 154.078125 L 134.558594 154.078125 C 134.503906 154.078125 134.460938 154.03125 134.460938 153.976562 L 134.460938 131.96875 C 134.460938 131.914062 134.503906 131.871094 134.558594 131.871094 L 139.425781 131.871094 C 139.457031 131.871094 139.488281 131.886719 139.503906 131.914062 L 148.523438 145.1875 C 148.578125 145.265625 148.703125 145.226562 148.703125 145.132812 L 148.703125 131.96875 C 148.703125 131.914062 148.746094 131.871094 148.800781 131.871094 L 153.585938 131.871094 C 153.644531 131.871094 153.6875 131.914062 153.6875 131.96875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "90a67be486"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 156.808594 131.820312 L 175.460938 131.820312 L 175.460938 154.519531 L 156.808594 154.519531 Z M 156.808594 131.820312 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "36f3398f27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 156.867188 145.449219 L 156.867188 131.964844 C 156.867188 131.910156 156.910156 131.867188 156.964844 131.867188 L 161.75 131.867188 C 161.804688 131.867188 161.847656 131.910156 161.847656 131.964844 L 161.847656 145.386719 C 161.847656 147.527344 163.230469 149.199219 165.234375 149.582031 C 167.929688 150.097656 170.402344 147.925781 170.402344 145.179688 L 170.402344 131.964844 C 170.402344 131.910156 170.445312 131.867188 170.5 131.867188 L 175.285156 131.867188 C 175.339844 131.867188 175.382812 131.910156 175.382812 131.964844 L 175.382812 145.449219 C 175.382812 150.597656 171.363281 154.460938 166.125 154.460938 C 160.851562 154.460938 156.867188 150.597656 156.867188 145.449219 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "86bead86fa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 177.042969 131.425781 L 195.300781 131.425781 L 195.300781 154.519531 L 177.042969 154.519531 Z M 177.042969 131.425781 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "34e9ebdc15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 177.101562 150.914062 L 179.5625 147.28125 C 179.597656 147.230469 179.664062 147.222656 179.707031 147.261719 C 181.507812 148.894531 184.132812 150.019531 186.441406 150.019531 C 188.4375 150.019531 190.136719 149.148438 190.136719 147.832031 C 190.136719 146.289062 188.015625 145.773438 185.667969 145.195312 C 181.230469 144.132812 177.921875 142.039062 177.921875 138.113281 C 177.921875 134.121094 181.363281 131.484375 186.472656 131.484375 C 189.84375 131.484375 192.613281 132.617188 194.261719 134.164062 L 194.300781 134.246094 L 192.066406 137.917969 C 192.03125 137.96875 191.964844 137.976562 191.917969 137.9375 C 190.625 136.757812 188.484375 135.925781 186.441406 135.925781 C 184.449219 135.925781 183.035156 136.761719 183.035156 137.921875 C 183.035156 139.371094 185.058594 140.042969 187.085938 140.464844 C 189.046875 140.882812 195.25 142.425781 195.25 147.609375 C 195.25 151.695312 191.425781 154.460938 186.472656 154.460938 C 183.066406 154.460938 179.4375 153.101562 177.121094 151.042969 L 177.074219 150.953125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "861408edf3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 202.164062 135.367188 L 206.929688 135.367188 L 206.929688 141.484375 L 202.164062 141.484375 Z M 202.164062 135.367188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e5c9faf4ad"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 204.765625 140.425781 C 205.089844 140.425781 205.324219 140.351562 205.472656 140.207031 C 205.617188 140.0625 205.691406 139.875 205.691406 139.640625 L 205.671875 139.417969 C 205.59375 139.230469 205.542969 139.15625 205.484375 139.105469 L 205.347656 139.007812 C 205.171875 138.9375 205.089844 138.914062 205.011719 138.902344 L 204.847656 138.886719 L 203.386719 138.886719 L 203.386719 140.425781 Z M 204.667969 136.425781 L 203.386719 136.425781 L 203.386719 137.9375 L 204.609375 137.9375 C 204.71875 137.9375 204.824219 137.925781 204.929688 137.902344 L 205.132812 137.84375 C 205.34375 137.738281 205.425781 137.65625 205.488281 137.550781 L 205.582031 137.316406 C 205.582031 136.949219 205.511719 136.769531 205.367188 136.632812 C 205.222656 136.5 204.992188 136.429688 204.667969 136.429688 M 205.984375 138.367188 C 206.277344 138.496094 206.503906 138.679688 206.664062 138.925781 C 206.828125 139.175781 206.910156 139.480469 206.910156 139.847656 C 206.910156 140.390625 206.726562 140.800781 206.355469 141.074219 C 205.988281 141.347656 205.464844 141.484375 204.789062 141.484375 L 202.164062 141.484375 L 202.164062 135.367188 L 204.542969 135.367188 C 205.234375 135.367188 205.761719 135.503906 206.132812 135.777344 C 206.507812 136.046875 206.691406 136.464844 206.691406 137.027344 C 206.691406 137.640625 206.457031 138.085938 205.984375 138.367188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c77c6975dd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 202.164062 145.847656 L 207.394531 145.847656 L 207.394531 151.972656 L 202.164062 151.972656 Z M 202.164062 145.847656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b2c7673c04"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 204.453125 150.816406 C 204.988281 150.816406 205.398438 150.65625 205.6875 150.339844 C 205.972656 150.019531 206.113281 149.546875 206.113281 148.917969 C 206.113281 148.285156 205.96875 147.804688 205.679688 147.484375 C 205.394531 147.160156 204.984375 147 204.453125 147 L 203.386719 147 L 203.386719 150.816406 Z M 204.597656 145.847656 C 205.441406 145.847656 206.113281 146.125 206.617188 146.679688 C 207.121094 147.234375 207.375 147.976562 207.375 148.902344 C 207.375 149.855469 207.128906 150.605469 206.636719 151.148438 C 206.144531 151.6875 205.464844 151.960938 204.597656 151.960938 L 202.164062 151.960938 L 202.164062 145.847656 Z M 204.597656 145.847656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "00b4bb22cc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 211.136719 135.367188 L 215.730469 135.367188 L 215.730469 141.492188 L 211.136719 141.492188 Z M 211.136719 135.367188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a55f89cb7b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 211.136719 141.484375 L 211.136719 135.367188 L 215.703125 135.367188 L 215.703125 136.535156 L 212.359375 136.535156 L 212.359375 137.820312 L 215.203125 137.820312 L 215.203125 138.992188 L 212.359375 138.992188 L 212.359375 140.308594 L 215.730469 140.308594 L 215.730469 141.480469 Z M 211.136719 141.484375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e40ca33368"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 211.609375 145.847656 L 216.175781 145.847656 L 216.175781 147.015625 L 211.609375 147.015625 Z M 211.609375 147.015625 L 212.832031 147.015625 L 212.832031 148.300781 L 211.609375 148.300781 Z M 211.609375 148.300781 L 215.675781 148.300781 L 215.675781 149.472656 L 211.609375 149.472656 Z M 211.609375 149.472656 L 212.832031 149.472656 L 212.832031 150.789062 L 211.609375 150.789062 Z M 211.609375 150.789062 L 216.203125 150.789062 L 216.203125 151.960938 L 211.609375 151.960938 Z M 211.609375 150.789062 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9fb93076f3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 219.980469 135.367188 L 225.40625 135.367188 L 225.40625 141.492188 L 219.980469 141.492188 Z M 219.980469 135.367188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "757471d667"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 224.164062 135.367188 L 225.386719 135.367188 L 225.386719 141.484375 L 224.480469 141.484375 L 221.203125 137.617188 L 221.203125 141.484375 L 219.980469 141.484375 L 219.980469 135.367188 L 220.882812 135.367188 L 224.164062 139.230469 Z M 224.164062 135.367188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4863987fef"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 225.351562 145.785156 L 230.148438 145.785156 L 230.148438 152.082031 L 225.351562 152.082031 Z M 225.351562 145.785156 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "10195c876d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 227.839844 152.066406 C 227.339844 152.066406 226.875 151.972656 226.441406 151.785156 C 226.003906 151.597656 225.644531 151.339844 225.351562 151.007812 L 226.015625 150.097656 C 226.328125 150.378906 226.609375 150.589844 226.859375 150.71875 C 227.109375 150.847656 227.394531 150.914062 227.714844 150.914062 C 228.039062 150.914062 228.304688 150.851562 228.507812 150.722656 C 228.714844 150.59375 228.816406 150.417969 228.816406 150.183594 C 228.816406 149.984375 228.734375 149.835938 228.574219 149.730469 C 228.410156 149.625 228.140625 149.527344 227.765625 149.433594 C 227.304688 149.316406 226.980469 149.222656 226.8125 149.160156 C 226.101562 148.890625 225.6875 148.484375 225.578125 147.929688 L 225.546875 147.703125 C 225.546875 147.039062 225.753906 146.605469 226.179688 146.277344 C 226.601562 145.949219 227.167969 145.785156 227.882812 145.785156 C 228.722656 145.785156 229.464844 146.039062 230.109375 146.550781 L 229.566406 147.515625 C 229.222656 147.300781 228.933594 147.144531 228.695312 147.046875 C 228.460938 146.953125 228.191406 146.902344 227.886719 146.902344 C 227.570312 146.902344 227.324219 146.960938 227.140625 147.074219 C 226.957031 147.183594 226.867188 147.351562 226.867188 147.558594 L 226.878906 147.703125 L 226.960938 147.878906 L 227.109375 148.007812 C 227.207031 148.070312 227.273438 148.097656 227.363281 148.128906 L 227.519531 148.179688 L 227.707031 148.222656 C 228.003906 148.292969 228.160156 148.328125 228.277344 148.355469 L 228.734375 148.492188 C 228.921875 148.554688 229.070312 148.613281 229.183594 148.671875 L 229.421875 148.808594 C 229.695312 149.007812 229.804688 149.113281 229.878906 149.222656 L 230.019531 149.472656 C 230.125 149.789062 230.148438 149.964844 230.148438 150.15625 C 230.148438 150.738281 229.9375 151.203125 229.511719 151.546875 C 229.085938 151.890625 228.53125 152.0625 227.839844 152.0625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "520e9109c8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 229.917969 135.367188 L 234.515625 135.367188 L 234.515625 141.492188 L 229.917969 141.492188 Z M 229.917969 135.367188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "249edaaaad"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 229.917969 141.484375 L 229.917969 135.367188 L 234.484375 135.367188 L 234.484375 136.535156 L 231.144531 136.535156 L 231.144531 137.820312 L 233.984375 137.820312 L 233.984375 138.992188 L 231.144531 138.992188 L 231.144531 140.308594 L 234.515625 140.308594 L 234.515625 141.480469 Z M 229.917969 141.484375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9f897bbe22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 233.878906 145.847656 L 239.972656 145.847656 L 239.972656 151.96875 L 233.878906 151.96875 Z M 233.878906 145.847656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cedb87ecf0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 236.089844 149.824219 L 237.824219 149.824219 L 236.988281 147.53125 Z M 238.601562 151.960938 L 238.183594 150.816406 L 235.695312 150.816406 L 235.25 151.960938 L 233.878906 151.960938 L 236.507812 145.847656 L 237.507812 145.847656 L 239.972656 151.960938 Z M 238.601562 151.960938 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "42a11c6112"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 238.761719 135.367188 L 243.328125 135.367188 L 243.328125 136.535156 L 238.761719 136.535156 Z M 238.761719 136.535156 L 239.988281 136.535156 L 239.988281 137.820312 L 238.761719 137.820312 Z M 238.761719 137.820312 L 242.828125 137.820312 L 242.828125 138.992188 L 238.761719 138.992188 Z M 238.761719 138.992188 L 239.988281 138.992188 L 239.988281 141.484375 L 238.761719 141.484375 Z M 238.761719 138.992188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4969689bd5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 243.878906 143.9375 L 249.1875 143.9375 L 249.1875 152.066406 L 243.878906 152.066406 Z M 243.878906 143.9375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f0a516d886"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 246.136719 145.265625 L 246.824219 143.9375 L 247.988281 143.9375 L 247.0625 145.265625 Z M 246.53125 152.050781 C 245.707031 152.050781 245.058594 151.792969 244.59375 151.277344 C 244.128906 150.761719 243.898438 150.066406 243.898438 149.1875 L 243.898438 145.847656 L 245.121094 145.847656 L 245.121094 149.175781 C 245.121094 150.273438 245.59375 150.824219 246.535156 150.824219 C 247.472656 150.824219 247.941406 150.273438 247.941406 149.175781 L 247.941406 145.847656 L 249.171875 145.847656 L 249.171875 149.1875 C 249.171875 150.066406 248.9375 150.761719 248.46875 151.277344 C 248.003906 151.789062 247.359375 152.050781 246.535156 152.050781 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c231cc7091"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 247.460938 133.457031 L 249.535156 133.457031 L 249.535156 141.488281 L 247.460938 141.488281 Z M 247.460938 133.457031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "778221b220"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 247.675781 134.789062 L 248.363281 133.457031 L 249.527344 133.457031 L 248.601562 134.789062 Z M 247.460938 135.371094 L 248.6875 135.371094 L 248.6875 141.480469 L 247.460938 141.480469 Z M 247.460938 135.371094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0dd9a25712"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 252.894531 135.308594 L 258.375 135.308594 L 258.375 141.597656 L 252.894531 141.597656 Z M 252.894531 135.308594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7bb4214240"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 256.285156 141.589844 C 255.195312 141.589844 254.359375 141.308594 253.773438 140.742188 C 253.191406 140.179688 252.894531 139.414062 252.894531 138.441406 C 252.894531 137.96875 252.96875 137.539062 253.113281 137.152344 C 253.257812 136.769531 253.46875 136.441406 253.75 136.167969 C 254.03125 135.890625 254.386719 135.683594 254.816406 135.53125 C 255.246094 135.382812 255.738281 135.308594 256.289062 135.308594 L 256.503906 135.3125 C 256.714844 135.324219 256.816406 135.332031 256.914062 135.34375 L 257.101562 135.371094 C 257.269531 135.394531 257.355469 135.414062 257.445312 135.4375 L 257.804688 135.527344 C 257.972656 135.578125 258.03125 135.59375 258.066406 135.605469 L 258.152344 135.636719 L 258.339844 135.703125 L 258.351562 136.9375 C 258.335938 136.933594 258.242188 136.894531 258.066406 136.820312 L 257.621094 136.652344 C 257.503906 136.609375 257.328125 136.570312 257.097656 136.527344 L 256.417969 136.460938 C 255.726562 136.460938 255.179688 136.632812 254.789062 136.980469 C 254.394531 137.324219 254.195312 137.8125 254.195312 138.445312 C 254.195312 139.078125 254.394531 139.566406 254.789062 139.914062 C 255.1875 140.261719 255.726562 140.433594 256.417969 140.433594 L 257.097656 140.367188 C 257.324219 140.324219 257.503906 140.277344 257.628906 140.234375 L 258.066406 140.0625 C 258.234375 139.992188 258.332031 139.953125 258.351562 139.945312 L 258.351562 141.179688 C 258.339844 141.183594 258.285156 141.203125 258.1875 141.234375 L 258.015625 141.296875 C 257.910156 141.328125 257.828125 141.355469 257.714844 141.386719 L 257.5 141.445312 C 257.3125 141.484375 257.203125 141.507812 257.078125 141.527344 L 256.824219 141.566406 C 256.558594 141.585938 256.421875 141.589844 256.285156 141.589844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "899c252fee"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 253.574219 145.847656 L 258.804688 145.847656 L 258.804688 151.972656 L 253.574219 151.972656 Z M 253.574219 145.847656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b527450108"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 255.863281 150.816406 C 256.398438 150.816406 256.808594 150.65625 257.09375 150.339844 C 257.382812 150.019531 257.523438 149.546875 257.523438 148.917969 C 257.523438 148.285156 257.378906 147.804688 257.089844 147.484375 C 256.800781 147.160156 256.394531 147 255.863281 147 L 254.796875 147 L 254.796875 150.816406 Z M 256.007812 145.847656 C 256.851562 145.847656 257.523438 146.125 258.027344 146.679688 C 258.53125 147.234375 258.785156 147.976562 258.785156 148.902344 C 258.785156 149.855469 258.535156 150.605469 258.042969 151.148438 C 257.550781 151.6875 256.871094 151.960938 256.007812 151.960938 L 253.574219 151.960938 L 253.574219 145.847656 Z M 256.007812 145.847656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6f84f1291b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 262.671875 135.367188 L 263.898438 135.367188 L 263.898438 141.484375 L 262.671875 141.484375 Z M 262.671875 135.367188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f747dd2475"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 263.019531 145.847656 L 267.582031 145.847656 L 267.582031 147.015625 L 263.019531 147.015625 Z M 263.019531 147.015625 L 264.242188 147.015625 L 264.242188 148.300781 L 263.019531 148.300781 Z M 263.019531 148.300781 L 267.085938 148.300781 L 267.085938 149.472656 L 263.019531 149.472656 Z M 263.019531 149.472656 L 264.242188 149.472656 L 264.242188 150.789062 L 263.019531 150.789062 Z M 263.019531 150.789062 L 267.613281 150.789062 L 267.613281 151.960938 L 263.019531 151.960938 Z M 263.019531 150.789062 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "39ef77692b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 268.128906 135.308594 L 274.34375 135.308594 L 274.34375 141.597656 L 268.128906 141.597656 Z M 268.128906 135.308594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1ded0719e0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 271.234375 140.433594 C 271.773438 140.433594 272.199219 140.269531 272.519531 139.929688 C 272.835938 139.59375 272.996094 139.109375 272.996094 138.472656 C 272.996094 137.835938 272.835938 137.339844 272.515625 136.988281 C 272.195312 136.636719 271.769531 136.460938 271.234375 136.460938 C 270.695312 136.460938 270.269531 136.636719 269.945312 136.988281 C 269.625 137.339844 269.464844 137.835938 269.464844 138.472656 C 269.464844 139.109375 269.621094 139.597656 269.941406 139.929688 C 270.257812 140.265625 270.6875 140.433594 271.234375 140.433594 M 271.234375 141.589844 C 270.28125 141.589844 269.527344 141.308594 268.96875 140.742188 C 268.40625 140.175781 268.128906 139.417969 268.128906 138.46875 C 268.128906 137.84375 268.253906 137.289062 268.507812 136.808594 C 268.761719 136.332031 269.121094 135.964844 269.589844 135.703125 C 270.0625 135.441406 270.609375 135.308594 271.234375 135.308594 C 271.859375 135.308594 272.410156 135.441406 272.878906 135.703125 C 273.351562 135.964844 273.714844 136.335938 273.964844 136.808594 C 274.214844 137.285156 274.34375 137.835938 274.34375 138.46875 C 274.34375 139.417969 274.0625 140.175781 273.5 140.738281 C 272.941406 141.304688 272.183594 141.589844 271.234375 141.589844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "310a12e54d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 278.167969 135.308594 L 282.964844 135.308594 L 282.964844 141.605469 L 278.167969 141.605469 Z M 278.167969 135.308594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3964027f20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 280.652344 141.589844 C 280.15625 141.589844 279.691406 141.496094 279.257812 141.308594 C 278.820312 141.117188 278.460938 140.863281 278.167969 140.53125 L 278.832031 139.617188 C 279.144531 139.902344 279.421875 140.109375 279.675781 140.242188 C 279.925781 140.371094 280.210938 140.4375 280.53125 140.4375 C 280.855469 140.4375 281.117188 140.375 281.324219 140.246094 C 281.53125 140.117188 281.632812 139.9375 281.632812 139.707031 C 281.632812 139.507812 281.550781 139.355469 281.390625 139.25 C 281.226562 139.148438 280.957031 139.046875 280.582031 138.953125 C 280.117188 138.835938 279.796875 138.746094 279.625 138.683594 C 278.914062 138.414062 278.503906 138.003906 278.394531 137.449219 L 278.359375 137.226562 C 278.359375 136.5625 278.570312 136.125 278.996094 135.796875 C 279.417969 135.472656 279.984375 135.308594 280.699219 135.308594 C 281.539062 135.308594 282.28125 135.5625 282.921875 136.074219 L 282.382812 137.042969 C 282.039062 136.824219 281.746094 136.667969 281.511719 136.570312 C 281.277344 136.476562 281.007812 136.429688 280.703125 136.429688 C 280.386719 136.429688 280.136719 136.484375 279.957031 136.597656 C 279.777344 136.710938 279.679688 136.871094 279.679688 137.082031 L 279.691406 137.222656 L 279.777344 137.402344 L 279.925781 137.53125 C 280.023438 137.59375 280.089844 137.621094 280.179688 137.652344 L 280.335938 137.703125 L 280.519531 137.75 C 280.820312 137.816406 280.976562 137.855469 281.09375 137.882812 L 281.550781 138.015625 C 281.738281 138.078125 281.886719 138.136719 281.996094 138.195312 L 282.234375 138.335938 C 282.511719 138.535156 282.617188 138.636719 282.691406 138.75 L 282.832031 138.996094 C 282.9375 139.316406 282.964844 139.488281 282.964844 139.683594 C 282.964844 140.265625 282.753906 140.726562 282.328125 141.074219 C 281.902344 141.417969 281.34375 141.589844 280.652344 141.589844 ",
    clipRule: "nonzero"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0 0 L 283 0 L 283 283 L 0 283 Z M 0 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0 0 L 283 0 L 283 283 L 0 283 Z M 0 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f944e868c2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3086f127f2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2558a6",
    d: "M 0 139.917969 L 17.679688 139.917969 L 17.679688 143.03125 L 0 143.03125 Z M 0 139.917969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c74243609b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7b9ae96faa)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2558a6",
    d: "M 5.488281 116.804688 L 27.1875 116.804688 L 27.1875 138.671875 L 5.488281 138.671875 Z M 5.488281 116.804688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5358a2b920)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8bbcba3d96)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2558a6",
    d: "M 5.488281 116.804688 L 27.1875 116.804688 L 27.1875 138.671875 L 5.488281 138.671875 Z M 5.488281 116.804688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#79fe00947f)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eb89b036df)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2558a6",
    d: "M 5.488281 116.804688 L 27.1875 116.804688 L 27.1875 138.671875 L 5.488281 138.671875 Z M 5.488281 116.804688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5a81e57fef)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f7a13e3cca)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2558a6",
    d: "M 5.636719 144.609375 L 27.503906 144.609375 L 27.503906 166.308594 L 5.636719 166.308594 Z M 5.636719 144.609375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9a9cc2447e)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3bfc993b0c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2558a6",
    d: "M 5.636719 144.609375 L 27.503906 144.609375 L 27.503906 166.308594 L 5.636719 166.308594 Z M 5.636719 144.609375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7e7e7d2554)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#384709e163)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2558a6",
    d: "M 5.636719 144.609375 L 27.503906 144.609375 L 27.503906 166.308594 L 5.636719 166.308594 Z M 5.636719 144.609375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a9c7b679c6)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1d7f968cda)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2558a6",
    d: "M 28.746094 111.167969 L 31.878906 111.167969 L 31.878906 128.851562 L 28.746094 128.851562 Z M 28.746094 111.167969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6cb9ff17bd)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#22b115e212)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2558a6",
    d: "M 28.75 154.109375 L 31.886719 154.109375 L 31.886719 171.792969 L 28.75 171.792969 Z M 28.75 154.109375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2f2fd899f3)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#da6fb42bf9)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#439fd8",
    d: "M 20.398438 139.910156 L 60.636719 139.910156 L 60.636719 143.050781 L 20.398438 143.050781 Z M 20.398438 139.910156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#676d3d5d58)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b052e07759)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2558a6",
    d: "M 33.140625 116.65625 L 55.007812 116.65625 L 55.007812 138.355469 L 33.140625 138.355469 Z M 33.140625 116.65625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#320047b467)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#af24011a15)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2558a6",
    d: "M 33.140625 116.65625 L 55.007812 116.65625 L 55.007812 138.355469 L 33.140625 138.355469 Z M 33.140625 116.65625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#81adba565b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e17ec89c99)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2558a6",
    d: "M 33.140625 116.65625 L 55.007812 116.65625 L 55.007812 138.355469 L 33.140625 138.355469 Z M 33.140625 116.65625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fc78b2c753)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b5e0733525)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2558a6",
    d: "M 33.445312 144.304688 L 55.144531 144.304688 L 55.144531 166.175781 L 33.445312 166.175781 Z M 33.445312 144.304688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2b548f57ae)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f3d71d8591)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2558a6",
    d: "M 33.445312 144.304688 L 55.144531 144.304688 L 55.144531 166.175781 L 33.445312 166.175781 Z M 33.445312 144.304688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5f7a565cc5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c137bb5eca)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2558a6",
    d: "M 33.445312 144.304688 L 55.144531 144.304688 L 55.144531 166.175781 L 33.445312 166.175781 Z M 33.445312 144.304688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#35feffa42d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#686313efae)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2558a6",
    d: "M 65.167969 130.339844 L 133.167969 130.339844 L 133.167969 155.605469 L 65.167969 155.605469 Z M 65.167969 130.339844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ca21ba3664)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6647ba72d7)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2558a6",
    d: "M 65.167969 130.339844 L 133.167969 130.339844 L 133.167969 155.605469 L 65.167969 155.605469 Z M 65.167969 130.339844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e9fd1788de)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#124538a016)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2558a6",
    d: "M 65.167969 130.339844 L 133.167969 130.339844 L 133.167969 155.605469 L 65.167969 155.605469 Z M 65.167969 130.339844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c6f2dc0695)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e0db156d11)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2558a6",
    d: "M 134.460938 131.871094 L 153.683594 131.871094 L 153.683594 154.097656 L 134.460938 154.097656 Z M 134.460938 131.871094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#90a67be486)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#36f3398f27)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2558a6",
    d: "M 155.722656 130.339844 L 196.386719 130.339844 L 196.386719 155.605469 L 155.722656 155.605469 Z M 155.722656 130.339844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#86bead86fa)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#34e9ebdc15)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2558a6",
    d: "M 155.722656 130.339844 L 196.386719 130.339844 L 196.386719 155.605469 L 155.722656 155.605469 Z M 155.722656 130.339844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#861408edf3)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e5c9faf4ad)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#439fd8",
    d: "M 202.164062 135.367188 L 206.910156 135.367188 L 206.910156 141.484375 L 202.164062 141.484375 Z M 202.164062 135.367188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c77c6975dd)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b2c7673c04)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#439fd8",
    d: "M 202.164062 145.847656 L 207.375 145.847656 L 207.375 151.953125 L 202.164062 151.953125 Z M 202.164062 145.847656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#00b4bb22cc)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a55f89cb7b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#439fd8",
    d: "M 211.136719 135.367188 L 215.730469 135.367188 L 215.730469 141.492188 L 211.136719 141.492188 Z M 211.136719 135.367188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e40ca33368)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#439fd8",
    d: "M 211.609375 145.847656 L 216.207031 145.847656 L 216.207031 151.96875 L 211.609375 151.96875 Z M 211.609375 145.847656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9fb93076f3)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#757471d667)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#439fd8",
    d: "M 219.980469 135.367188 L 225.386719 135.367188 L 225.386719 141.492188 L 219.980469 141.492188 Z M 219.980469 135.367188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4863987fef)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#10195c876d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#439fd8",
    d: "M 225.351562 145.785156 L 230.148438 145.785156 L 230.148438 152.0625 L 225.351562 152.0625 Z M 225.351562 145.785156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#520e9109c8)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#249edaaaad)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#439fd8",
    d: "M 229.917969 135.367188 L 234.515625 135.367188 L 234.515625 141.492188 L 229.917969 141.492188 Z M 229.917969 135.367188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9f897bbe22)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cedb87ecf0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#439fd8",
    d: "M 233.878906 145.847656 L 239.972656 145.847656 L 239.972656 151.96875 L 233.878906 151.96875 Z M 233.878906 145.847656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#42a11c6112)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#439fd8",
    d: "M 238.761719 135.367188 L 243.328125 135.367188 L 243.328125 141.488281 L 238.761719 141.488281 Z M 238.761719 135.367188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4969689bd5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f0a516d886)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#439fd8",
    d: "M 243.898438 143.9375 L 249.167969 143.9375 L 249.167969 152.046875 L 243.898438 152.046875 Z M 243.898438 143.9375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c231cc7091)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#778221b220)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#439fd8",
    d: "M 247.460938 133.457031 L 249.527344 133.457031 L 249.527344 141.480469 L 247.460938 141.480469 Z M 247.460938 133.457031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0dd9a25712)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7bb4214240)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#439fd8",
    d: "M 252.894531 135.308594 L 258.351562 135.308594 L 258.351562 141.597656 L 252.894531 141.597656 Z M 252.894531 135.308594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#899c252fee)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b527450108)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#439fd8",
    d: "M 253.574219 145.847656 L 258.785156 145.847656 L 258.785156 151.953125 L 253.574219 151.953125 Z M 253.574219 145.847656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6f84f1291b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#439fd8",
    d: "M 262.671875 135.367188 L 263.898438 135.367188 L 263.898438 141.484375 L 262.671875 141.484375 Z M 262.671875 135.367188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f747dd2475)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#439fd8",
    d: "M 263.019531 145.847656 L 267.613281 145.847656 L 267.613281 151.96875 L 263.019531 151.96875 Z M 263.019531 145.847656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#39ef77692b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1ded0719e0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#439fd8",
    d: "M 268.128906 135.308594 L 274.34375 135.308594 L 274.34375 141.597656 L 268.128906 141.597656 Z M 268.128906 135.308594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#310a12e54d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3964027f20)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#439fd8",
    d: "M 278.167969 135.308594 L 282.964844 135.308594 L 282.964844 141.585938 L 278.167969 141.585938 Z M 278.167969 135.308594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogologin);
export default __webpack_public_path__ + "static/media/logo login.6e7aa2720e0a4e4d82e30a68efc4e829.svg";
export { ForwardRef as ReactComponent };